import { DEFAULT_BUSINESS_PIC, LOGIN_UNIFICADO } from "@/configs/runtime";
import { Divider } from "@mui/material";

function SignInPageTitle() {
	return (
		<div className="mb-8 flex items-center justify-center gap-3.5 group-data-[densidade=compacta]/login:mb-5">
			<img
				className="h-10 w-29.5 object-contain object-center group-data-[densidade=compacta]/login:h-9"
				src="/assets/space/logo_space_blue.png"
				alt="Space Software"
			/>

			{DEFAULT_BUSINESS_PIC && !LOGIN_UNIFICADO ? (
				<>
					<Divider orientation="vertical" flexItem variant="middle" />
					<div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-lg">
						<img
							alt="Logo da empresa"
							src={DEFAULT_BUSINESS_PIC}
							className="h-full w-full object-contain"
						/>
					</div>
				</>
			) : null}
		</div>
	);
}

export default SignInPageTitle;
